const applets = [
    {
        "text": "Case Basic Information",
        "icon": "/image/business/newborn.svg",
        "id": "NewbornApplet",
        "path": "newborn"
    },
    {
        "text": "Screening List",
        "icon": "/image/business/screening-list.svg",
        "id": "ScreeningListApplet",
        "path": "screeningList"
    },
    {
        "text": "Update Collection Date",
        "icon": "/image/business/update-collection-date.svg",
        "id": "UpdateCollectionDateApplet",
        "path": "updateCollectionDate"
    },
    {
        "text": "Update Send Uid Date",
        "icon": "/image/business/update-test-date.svg",
        "id": "UpdateTestDateApplet",
        "path": "updateTestDate"
    },
    {
        "text": "Print Send Uid List/Send Uid Form",
        "icon": "/image/business/test-list.svg",
        "id": "TestListApplet",
        "path": "testList"
    },
    {
        "text": "Screening Result Searching",
        "icon": "/image/business/screeningResult.svg",
        "id": "ScreeningResultsApplet",
        "path": "screeningResults"
    },
]


export default applets;